import { CommunityList, CommunityRequest } from "components";
import FeedLayout from "layouts/files/FeedLayout";
import { useState } from "react";
import { Link } from "react-router-dom";
import { Button, IconInput } from "ui";

export type DemoComunityListObject = {
    title: string;
    img: string;
    id: string;
    members: string;
    newPosts: number;
    about?: string;
};
import { demoCommunityListingImg } from "utils/assets_exports/images";

const CommunityListing = () => {
    const demoUrGroups: DemoComunityListObject[] = [
        {
            newPosts: 11,
            title: "The family gamers world community",
            id: "@familygamers",
            members: "5.7k",
            img: demoCommunityListingImg[0]
        },
        {
            newPosts: 64,
            title: "Grandma's cake and cookies oven",
            id: "@grandmaoven",
            members: "12.9k",
            img: demoCommunityListingImg[1]
        },
        {
            newPosts: 21,
            title: "The house of casual fashionistas",
            id: "@casualfashionistas",
            members: "3.7k",
            img: demoCommunityListingImg[2]
        },
        {
            newPosts: 2,
            title: "Tales of fire, ice, and flying dragons",
            id: "@flyingdragons",
            members: "2.3k",
            img: demoCommunityListingImg[3]
        },
        {
            newPosts: 78,
            title: "Passionates of mountain trekking and adventure",
            id: "@passionatesofmountain",
            members: "6.1k",
            img: demoCommunityListingImg[4]
        },
        {
            newPosts: 45,
            title: "Keep your life balanced - for remote workers",
            id: "@lifebalanced",
            members: "78.5k",
            img: demoCommunityListingImg[5]
        },
        {
            newPosts: 68,
            title: "Latest straming releases and reviews",
            id: "@stramingreleases",
            members: "686.5k",
            img: demoCommunityListingImg[6]
        },
        {
            newPosts: 14,
            title: "Creative and healthy recipes for grown ups",
            id: "@familygamers",
            members: "15.7k",
            img: demoCommunityListingImg[7]
        }
    ];

    const demoListedGroups: DemoComunityListObject[] = [
        {
            newPosts: 7,
            title: "House of the Beer Experts Society",
            id: "@beerexperts",
            members: "3.4k",
            img: demoCommunityListingImg[8]
        },
        {
            newPosts: 13,
            title: "Zombie movies fans (only the good ones)",
            id: "@zombiemoviesfans",
            members: "12.6k",
            img: demoCommunityListingImg[9]
        },
        {
            newPosts: 44,
            title: "Seventies and Eighties music classics",
            id: "@musicclassics",
            members: "125.4k",
            img: demoCommunityListingImg[10]
        },
        {
            newPosts: 56,
            title: "XVI - XIX European classic paintings",
            id: "@euroclassicpaintings",
            members: "210k",
            img: demoCommunityListingImg[11]
        },
        {
            newPosts: 84,
            title: "Book lovers association of Kansas",
            id: "@kansasbooklovers",
            members: "3k",
            img: demoCommunityListingImg[12]
        },
        {
            newPosts: 210,
            title: "Cryptocurrency exchange and discussion group",
            id: "@cryptoexchange",
            members: "210.3k",
            img: demoCommunityListingImg[13]
        },
        {
            newPosts: 3,
            title: "Scary stories of Edgar A. Poe & HP Lovecraft",
            id: "@scarystories",
            members: "1.7k",
            img: demoCommunityListingImg[14]
        },
        {
            newPosts: 16,
            title: "Train trips accross Europe and Asia",
            id: "@traintrips",
            members: "203k",
            img: demoCommunityListingImg[15]
        },
        {
            newPosts: 2,
            title: "The Milwaukee automotive pit stop",
            id: "@milwaukeeautomotive",
            members: "798",
            img: demoCommunityListingImg[16]
        }
    ];
    const demoGroupsRequest: DemoComunityListObject[] = [
        {
            newPosts: 7,
            title: "House of the Beer Experts Society",
            id: "@beerexperts",
            about: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Voluptates, eaque!",
            members: "3.4k",
            img: demoCommunityListingImg[8]
        },
        {
            newPosts: 13,
            title: "Zombie movies fans (only the good ones)",
            id: "@zombiemoviesfans",
            about: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Voluptates, eaque!",
            members: "12.6k",
            img: demoCommunityListingImg[9]
        }
    ];
    const demoAllGroups: DemoComunityListObject[] = [
        {
            newPosts: 11,
            title: "The family gamers world community",
            id: "@familygamers",
            members: "5.7k",
            img: demoCommunityListingImg[0]
        },
        {
            newPosts: 64,
            title: "Grandma's cake and cookies oven",
            id: "@grandmaoven",
            members: "12.9k",
            img: demoCommunityListingImg[1]
        },
        {
            newPosts: 21,
            title: "The house of casual fashionistas",
            id: "@casualfashionistas",
            members: "3.7k",
            img: demoCommunityListingImg[2]
        },
        {
            newPosts: 2,
            title: "Tales of fire, ice, and flying dragons",
            id: "@flyingdragons",
            members: "2.3k",
            img: demoCommunityListingImg[3]
        },
        {
            newPosts: 78,
            title: "Passionates of mountain trekking and adventure",
            id: "@passionatesofmountain",
            members: "6.1k",
            img: demoCommunityListingImg[4]
        },
        {
            newPosts: 45,
            title: "Keep your life balanced - for remote workers",
            id: "@lifebalanced",
            members: "78.5k",
            img: demoCommunityListingImg[5]
        },
        {
            newPosts: 68,
            title: "Latest straming releases and reviews",
            id: "@stramingreleases",
            members: "686.5k",
            img: demoCommunityListingImg[6]
        },
        {
            newPosts: 14,
            title: "Creative and healthy recipes for grown ups",
            id: "@healthyrecipes",
            members: "15.7k",
            img: demoCommunityListingImg[7]
        },
        {
            newPosts: 7,
            title: "House of the Beer Experts Society",
            id: "@beerexperts",
            members: "3.4k",
            img: demoCommunityListingImg[8]
        },
        {
            newPosts: 13,
            title: "Zombie movies fans (only the good ones)",
            id: "@zombiemoviesfans",
            members: "12.6k",
            img: demoCommunityListingImg[9]
        },
        {
            newPosts: 44,
            title: "Seventies and Eighties music classics",
            id: "@musicclassics",
            members: "125.4k",
            img: demoCommunityListingImg[10]
        },
        {
            newPosts: 56,
            title: "XVI - XIX European classic paintings",
            id: "@euroclassicpaintings",
            members: "210k",
            img: demoCommunityListingImg[11]
        },
        {
            newPosts: 84,
            title: "Book lovers association of Kansas",
            id: "@kansasbooklovers",
            members: "3k",
            img: demoCommunityListingImg[12]
        },
        {
            newPosts: 210,
            title: "Cryptocurrency exchange and discussion group",
            id: "@cryptoexchange",
            members: "210.3k",
            img: demoCommunityListingImg[13]
        },
        {
            newPosts: 3,
            title: "Scary stories of Edgar A. Poe & HP Lovecraft",
            id: "@scarystories",
            members: "1.7k",
            img: demoCommunityListingImg[14]
        },
        {
            newPosts: 16,
            title: "Train trips accross Europe and Asia",
            id: "@traintrips",
            members: "203k",
            img: demoCommunityListingImg[15]
        },
        {
            newPosts: 2,
            title: "The Milwaukee automotive pit stop",
            id: "@milwaukeeautomotive",
            members: "798",
            img: demoCommunityListingImg[16]
        }
    ];

    const [communityList, setCommunityList] = useState<
        "Your Groups" | "Listed Groups" | "Groups Request" | "All Groups"
    >("Your Groups");
    const [filterVal, setFilterVal] = useState("");
    return (
        <FeedLayout pageTitle="Communities">
            <div className="groups-grid h-full community-listing-page">
                <div className="columns is-multiline ">
                    <div className="box-heading mt-20 mb-30">
                        <Button
                            text="Your Groups"
                            color=""
                            className={
                                communityList == "Your Groups"
                                    ? "is-active"
                                    : ""
                            }
                            handleClick={() => setCommunityList("Your Groups")}
                        />
                        <Button
                            text="Listed Groups"
                            color=""
                            className={
                                communityList == "Listed Groups"
                                    ? "is-active"
                                    : ""
                            }
                            handleClick={() =>
                                setCommunityList("Listed Groups")
                            }
                        />
                        <Button
                            text="Groups Request"
                            color=""
                            className={
                                communityList == "Groups Request"
                                    ? "is-active"
                                    : ""
                            }
                            handleClick={() =>
                                setCommunityList("Groups Request")
                            }
                        />
                        <Button
                            text="All Groups"
                            color=""
                            className={
                                communityList == "All Groups" ? "is-active" : ""
                            }
                            handleClick={() => setCommunityList("All Groups")}
                        />
                        <Link
                            to="/communities/create-community"
                            className="button"
                        >
                            Add Group
                        </Link>
                        {/* <Button text="Add Group" color="" /> */}
                    </div>
                    <div className="d-flex flex-j-between flex-a-center mb-20 w-full pr-10 pl-10">
                        <h1>{communityList}</h1>
                        <IconInput
                            rounded
                            value={filterVal}
                            handleChange={(
                                e: React.ChangeEvent<HTMLInputElement>
                            ) => setFilterVal(e.target.value)}
                        />
                    </div>
                    {/* your groups */}
                    <div
                        className={
                            communityList != "Your Groups"
                                ? "is-hidden"
                                : "columns is-multiline"
                        }
                    >
                        {demoUrGroups.map((i) => (
                            <CommunityList listItem={i} key={i.id} />
                        ))}
                    </div>
                    {/* listed groups */}
                    <div
                        className={
                            communityList != "Listed Groups"
                                ? "is-hidden"
                                : "columns is-multiline"
                        }
                    >
                        {demoListedGroups.map((i) => (
                            <CommunityList listItem={i} key={i.id} />
                        ))}
                    </div>
                    {/* groups requests */}
                    <div
                        className={
                            communityList != "Groups Request"
                                ? "is-hidden"
                                : "d-flex flex-col flex-j-start flex-a-center gap-20 w-full"
                        }
                    >
                        {demoGroupsRequest.map((i) => (
                            <CommunityRequest listItem={i} />
                        ))}
                    </div>
                    {/* all requests */}
                    <div
                        className={
                            communityList != "All Groups"
                                ? "is-hidden"
                                : "columns is-multiline"
                        }
                    >
                        {demoAllGroups.map((i) => (
                            <CommunityList listItem={i} key={i.id} />
                        ))}
                    </div>
                </div>

                {/* <!-- Load more groups --> */}
                <div className="load-more-wrap narrow-top has-text-centered mt-auto">
                    <a href="#" className="load-more-button">
                        Load More
                    </a>
                </div>
            </div>
        </FeedLayout>
    );
};

export default CommunityListing;
